<template>
  <div
    class="card"
    :class="[{selected:outlined}, paddingClass]"
  >
    <slot>Default Card html</slot>
  </div>
</template>

<script>

export default {
  name: 'Card',
  props: {
    outlined: {
      type: Boolean,
      required: false,
      default: false,
    },
    paddingClass: {
      type: String,
      required: false,
      default: 'padding-xs',
    },
  },
};
</script>

<style lang="scss" scoped>
.card {
  border: rem-calc(1px) solid $gray-2-color;
  &.selected {
    border: rem-calc(2px) solid $black;
  }
}
</style>

<style lang="scss" brand="mcom" scoped>
.card {
  &.selected {
    border-radius: rem-calc(5px);
  }
}
</style>
